import React, {useState, useEffect} from "react";
import {ComboCard, StyledComboCreator} from "./ComboCreator.style";
import Button from "components/molecules/Button";
import lunchSpecial from "../../../../assets/lunchSpecial.png";
import lunchSpecial2 from "../../../../assets/lunchSpecial2.png";
import lunchSpecial3 from "../../../../assets/lunchSpecial3.png";
import calendarIcon from "../../../../assets/calendarIcon.svg";
import clockIcon from "../../../../assets/clockIcon.svg";
import trashIcon from "../../../../assets/trashIcon.svg";
import editIcon from "../../../../assets/editIcon.svg";
import ModalContainer from "components/molecules/ModalContainer";
import CreateCumboModal from "./CreateCumboModal";
import CenterModal from "components/molecules/Modal/CenterModal";
import SuccessModal from "components/atoms/SuccessModal";
import menuStoreService from "services/menu-storeService";
import {useAuthContext} from "Context/authContext";
import {useSelector} from "react-redux";
import Toast from "components/molecules/Toast";
import DeleteModal from "components/atoms/DeleteModal/Index";

const comboData = [
    {
        img: lunchSpecial,
        title: "Lunch Special",
        popular: true,
        active: true,
        desc: "Perfect combo for your lunch break",
        includes: "Chicken Burger, Fries, Coke",
        time: "12:00 PM - 4:00 PM",
        price: "6.99",
    },
    {
        img: lunchSpecial2,
        title: "Family Bucket",
        desc: "Great for sharing with family",
        includes: "2 Burgers, 2 Fries, 2 Drinks",
        time: "All Day",
        price: "14.99",
    },
    {
        img: lunchSpecial3,
        title: "Lunch Special",
        active: true,
        desc: "Perfect combo for your lunch break",
        includes: "Chicken Burger, Fries, Coke",
        time: "12:00 PM - 4:00 PM",
        price: "8.99",
    },
    {
        img: lunchSpecial,
        title: "Lunch Special",
        popular: true,
        active: true,
        desc: "Perfect combo for your lunch break",
        includes: "Chicken Burger, Fries, Coke",
        time: "12:00 PM - 4:00 PM",
        price: "16.99",
    },
];

const ComboCreator = () => {
    const [successModal, setSuccessModal] = useState(false);
    const [combos, setCombos] = useState([]);
    const [loading, setLoading] = useState(false);
    const {fetch} = useAuthContext();
    const {defaultStore} = useSelector(state => state.business);
    const {hasPermission} = useAuthContext("hasPermission");

    const fetchCombos = async () => {
        if (!defaultStore) return;
        
        setLoading(true);
        try {
            const res = await menuStoreService.getCombos(defaultStore);
            setCombos(res?.data || []);
        } catch (error) {
            console.error("Error fetching combos:", error);
            Toast({
                type: "error",
                message: "Failed to fetch combos",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCombos();
    }, [defaultStore, fetch]);

    const handleDelete = async (comboId) => {
        try {
            const res = await menuStoreService.deleteCombo(comboId);
            Toast({
                type: "success",
                message: res?.message || "Combo deleted successfully",
            });
            fetchCombos();
        } catch (error) {
            Toast({
                type: "error",
                message: error?.message || "Failed to delete combo",
            });
        }
    };

    const handleToggleAvailability = async (combo) => {
        try {
            const payload = {
                ...combo,
                availability: combo.availability === "Available" ? "Out of Stock" : "Available"
            };
            await menuStoreService.updateCombo(payload, combo._id);
            Toast({
                type: "success",
                message: "Combo availability updated successfully",
            });
            fetchCombos();
        } catch (error) {
            Toast({
                type: "error",
                message: "Failed to update combo availability",
            });
        }
    };

    return (
        <StyledComboCreator>
            <CenterModal open={successModal} setOpen={setSuccessModal} width="579">
                <SuccessModal heading="Combo Creator Add Successfully!" />
            </CenterModal>
            <div className="btn-holder">
                {hasPermission("menu-management.add-combo") && (
                    <ModalContainer
                        width="983"
                        title="Create New Combo"
                        content={({onClose}) => (
                            <CreateCumboModal 
                                setSuccessModal={setSuccessModal} 
                                onClose={onClose}
                                onSuccess={() => {
                                    fetchCombos();
                                    onClose();
                                }}
                            />
                        )}
                        btnComponent={({onClick}) => (
                            <Button variant="primary" width="148px" onClick={onClick}>
                                Create Combo
                            </Button>
                        )}
                    />
                )}
            </div>
            {loading ? (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    Loading combos...
                </div>
            ) : combos.length > 0 ? (
                combos.map((data, index) => (
                    <ComboCard key={data._id || index}>
                        <img 
                            src={data?.comboImage || lunchSpecial} 
                            alt={data?.comboName} 
                            className="combo-img" 
                        />
                        <div className="details-wrap">
                            <div className="col-1">
                                <div className="title-wrap">
                                    <h2 className="title">{data?.comboName}</h2>
                                    {data?.priority === 1 && <span className="status popular">Popular</span>}
                                    {data?.availability === "Available" ? (
                                        <span className="status active">Active</span>
                                    ) : (
                                        <span className="status inactive">Inactive</span>
                                    )}
                                </div>
                                <span className="desc">{data?.description}</span>
                                <span className="includes">
                                    <strong>Includes:</strong> {data?.itemCount || 0} items
                                </span>
                                <div className="duration-wrap">
                                    <span className="duration">
                                        <img src={calendarIcon} alt="calendarIcon" />
                                        Available all day
                                    </span>
                                    <span className="duration">
                                        <img src={clockIcon} alt="clockIcon" />
                                        Always available
                                    </span>
                                </div>
                            </div>
                            <div className="col-2">
                                <h4 className="price">${data?.comboPrice}</h4>
                                {data?.originalPrice > data?.comboPrice && (
                                    <span className="discount">
                                        <del>${data?.originalPrice}</del>
                                        Save {data?.discountPercentage}%
                                    </span>
                                )}
                                <span className="sold">Priority: {data?.priority || 0}</span>
                                <div className="btn-wrap">
                                    <Button 
                                        width="114px" 
                                        $outline 
                                        className="btn"
                                        onClick={() => handleToggleAvailability(data)}
                                    >
                                        {data?.availability === "Available" ? "Deactivate" : "Activate"}
                                    </Button>
                                    {hasPermission("menu-management.edit-combo") && (
                                        <div className="editIcon">
                                            <ModalContainer
                                                width="983"
                                                title="Edit Combo"
                                                btnComponent={({onClick}) => (
                                                    <img src={editIcon} alt="editIcon" onClick={onClick} />
                                                )}
                                                content={({onClose}) => (
                                                    <CreateCumboModal 
                                                        comboData={data}
                                                        isEdit={true}
                                                        onClose={onClose}
                                                        onSuccess={() => {
                                                            fetchCombos();
                                                            onClose();
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    )}
                                    {hasPermission("menu-management.delete-combo") && (
                                        <div className="deleteIcon">
                                            <ModalContainer
                                                width={450}
                                                noBorder
                                                btnComponent={({onClick}) => (
                                                    <img src={trashIcon} alt="trashIcon" onClick={onClick} />
                                                )}
                                                content={({onClose}) => (
                                                    <DeleteModal
                                                        onSubmit={() => handleDelete(data._id)}
                                                        title="Are you sure you want to Delete this Combo?"
                                                        successTitle="Combo Deleted Successfully!"
                                                        onClose={onClose}
                                                    />
                                                )}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </ComboCard>
                ))
            ) : (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    No combos found. Create your first combo!
                </div>
            )}
        </StyledComboCreator>
    );
};

export default ComboCreator;
